if (!window.active_cfg) {
    throw '配置文件不存在';
}

window.domainList = {
    dyactive2: 'http://dyactive2.vip.xunlei.com',
    dyactive: 'http://dyactive.vip.xunlei.com',
    dyact: 'http://dyact.vip.xunlei.com',
    dynamic: 'http://dynamic.vip.xunlei.com',
    dypay: 'http://dypay.vip.xunlei.com',
    act: 'http://act.vip.xunlei.com',
    vip: 'http://vip.xunlei.com'
}

window.actid = active_cfg.base.actid;
document.title = active_cfg.base.actname;
document.domain = 'xunlei.com';
document.addEventListener('touchstart', function() {});

// var msgbox = require('./msgbox.js');
// var util = require('./util.js');
import $ from 'zepto';
import msgbox from './msgbox.js';
import util from './util.js';
var ajax = util.ajax;
import shouleiLogin from './login.js';

(function($) {
    //修改zepto的方法，增加innerWidth、innerHeight和outerWidth、outerHeight
    var ioDim = function(dimension, includeBorder) {
        return function(includeMargin) {
            var sides, size, elem, oldStyle;
            if (this) {
                elem = this;
                size = elem[dimension]();
                sides = {
                    width: ["left", "right"],
                    height: ["top", "bottom"]
                };
                sides[dimension].forEach(function(side) {
                    size += parseInt(elem.css("padding-" + side), 10);
                    if (includeBorder) {
                        size += parseInt(elem.css("border-" + side + "-width"), 10);
                    }
                    if (includeMargin) {
                        size += parseInt(elem.css("margin-" + side), 10);
                    }
                });
                return size;
            } else {
                return null;
            }
        }
    };
    ["width", "height"].forEach(function(dimension) {
        var Dimension = dimension.substr(0, 1).toUpperCase() + dimension.substr(1);
        $.fn["inner" + Dimension] = ioDim(dimension, false);
        $.fn["outer" + Dimension] = ioDim(dimension, true);
    });

	//由于引用了fx_methods.js，导致show方法会修改元素的样式，现在重写为原来的show方法
    $.fn.show = function() {
        return this.each(function() {
            this.style.display == "none" && (this.style.display = '');
            if (getComputedStyle(this, '').getPropertyValue("display") == "none") {
                this.style.display = defaultDisplay(this.nodeName);
            }
        })
    }

    function defaultDisplay(nodeName) {
        let element, display, elementDisplay = {};
        if (!elementDisplay[nodeName]) {
            element = document.createElement(nodeName);
            document.body.appendChild(element);
            display = getComputedStyle(element, '').getPropertyValue("display");
            element.parentNode.removeChild(element);
            display == "none" && (display = "block");
            elementDisplay[nodeName] = display;
        }
        return elementDisplay[nodeName]
    }
})($);

$.jsonp = function(url, data, callback) {
    if (typeof data === 'function') {
        callback = data;
        data = '';
    }

    let _callback = function(rs) {
        if (rs.result === -100) {
            setCookie('sessionid', '', 0, 1);
            setCookie('userid', '', 0, 1);
            logout();
            login();
        } else {
            callback(rs);
        }
    }

    return $.ajax({
        url,
        data,
        dataType: 'jsonp',
        success: _callback
    });
}

var times = 0;

function start() {
    init();

    if (util.isShouLei()) {
        try {
            //在手雷里面全部在当前页面跳转
            window.open = function(url) {
                window.top.location.href = url;
                return false;
            }

            var sessionid = window.share.getSessionId();
            var userid = window.share.getUserId();
            if (sessionid && userid) {
                setCookie('sessionid', sessionid, 24, 1);
                setCookie('userid', userid, 24, 1);
                times++;
                loginInit();
            } else {
                loginInit.fail && loginInit.fail();
            }
        } catch (e) {
            util.initUserInfo(function() {
                times++;
        		loginInit();
        	});
        }
        //手雷监听事件
        document.addEventListener('XLJSWebViewBridgejsReady', function() {
            if (times >= 1) {
                return false;
            }
            util.initUserInfo(function() {
                loginInit();
            });
        }, false);
    }
    //非手雷
    if (haslogin() && !util.isShouLei()) {
        loginInit();
    } else {
        loginInit.fail && loginInit.fail();
    }

}

function init() {
    ajax('http://dyactive2.vip.xunlei.com/iface/?action=init&keyurl=wap&actid=' + actid, function(rs) {
        if (rs.result == 0) {
            var data = rs.data;
            data.message && msgbox.showErrorMsg(data.message);
            init.cb && init.cb(data);
        }
    });
}

function onInit(cb) {
    init.cb = cb;
}

function loginInit() {
    $.jsonp(domainList.dyactive2 + '/iface/?action=logininit&keyurl=wap&actid=' + actid, {
        userInfo: 1
    }, function(rs) {
        if (rs.result == 0) {
            var data = rs.data;
            rs.data.message && msgbox.showErrorMsg(rs.data.message);
            refreshVipUserInfo(data.userInfo);
            loginInit.suc && loginInit.suc(data);
        } else if (rs.result === -100) {
            setCookie('sessionid', '', 0, 1);
            setCookie('userid', '', 0, 1);
            loginInit.fail && loginInit.fail();
        }
    });
}

window.loginInit = loginInit;

function onLoginInit(suc, fail) {
    loginInit.suc = suc;
    loginInit.fail = fail;
}

function refreshVipUserInfo(data) {
    if (!data) {
        return;
    }
    setCookie('vip_sessionid', getCookie('sessionid'));
    var regcookie = function(cname, name) {
        if (data[name] != undefined) setCookie(cname, data[name]);
    };
    regcookie('vip_nickname', 'nickname');
    regcookie('vip_usrname', 'usrname');
    regcookie('vip_growvalue', 'growvalue');
    regcookie('vip_expiredate', 'expiredate');
    regcookie('vip_level', 'level');
    regcookie('vip_isyear', 'isyear');
    regcookie('vip_paytype', 'paytype');
    regcookie('vip_isvip', 'isvip');
    regcookie('vip_daily', 'daily');
    regcookie('vip_payname', 'payname');
    regcookie('vip_is_good_number', 'is_good_number');
    regcookie('vip_num_is_open_vip', 'num_is_open_vip');
    regcookie('vip_num_due_time', 'num_due_time');
    regcookie('vip_safebox', 'safebox');
    regcookie('vip_autopay', 'autopay');
    regcookie('act_cmb', 'act_cmb');
    regcookie('vas_type', 'vas_type');
    regcookie('vip_ischild', 'ischild');
    regcookie('vip_kn_isvip', 'kn_isvip');
    regcookie('vip_kn_level', 'kn_level');
    regcookie('vip_kn_expiredate', 'kn_expiredate');
    regcookie('kn_isvip', 'kn_isvip');
    regcookie('kn_level', 'kn_level');
    regcookie('kn_expiredate', 'kn_expiredate');
}

export default {
    start: start,
    onInit: onInit,
    onLoginInit: onLoginInit,
    init: init,
    loginInit: loginInit
}



// WEBPACK FOOTER //
// ./src/common/main.js